import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    remadv: {
      tableData: [],
      totalRemadv: 0
    },
    remadvLines: {
      tableData: [],
      totalRemadvLines: 0
    },
    queryRemadv: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo(),
      // Filtros alineados con SearchRemadvRequestTO
      projectIds: [],
      buyerIds: [],
      sellerIds: [],
      centrePayerIds: [],
      remadvNumber: '',
      invoiceNumber: '',
      issueDateFrom: null,
      issueDateTo: null,
      documentDateFrom: null,
      documentDateTo: null,
      totalAmountFrom: null,
      totalAmountTo: null
    },
    listSelectedFiltersRemadv: [],
    optionsFilterServiceRemadv: [],
    optionsFilterBuyerRemadv: [],
    optionsFilterCentrePayeeRemadv: [],
    optionsFilterSellerRemadv: [],
    optionsFilterRemadvNumberRemadv: [],
    optionsFilterInvoiceNumberRemadv: [],
    optionsFilterIssueDateRemadv: [],
    optionsFilterTotalAmountRemadv: [],
    optionsFilterDocumentDateRemadv: []
  }
  return session
}

function initLocal () {
  // Columnas de la tabla principal segun especificación
  const local = {
    isShowServiceRemadv: true, // nueva columna service
    isShowBuyerRemadv: true,
    isShowCentrePayeeRemadv: true, // centro pagador (code + name)
    isShowSellerRemadv: true,
    isShowRemadvNumberRemadv: true,
    isShowDateCreationRemadv: true, // fecha documento (creationDateTime)
    isShowDateIssueRemadv: true, // fecha emisión (issueDate)
    isShowTotalAmountRemadv: true,
    isShowActionsRemadv: true,

    // Columnas líneas remadv (detalle)
    isShowLineNumberRemadvLine: true, // nuevo flag número de línea
    isShowDocumentNumberRemadvLine: true,
    isShowDocumentDateRemadvLine: true,
    isShowDocumentAmountRemadvLine: true,
    isShowCentreRemadvLine: true, // centreCode + centreDescription
    isShowCentreDescriptionRemadvLine: true,
    isShowCurrencyRemadvLine: true,
    isShowPaymentDateRemadvLine: true,
    isShowActionsRemadvLine: true
  }
  return local
}
function setByUserLocalRemadv () {
  const stored = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
  if (stored?.remadv) {
    const migrated = { ...stored.remadv }
    return { ...initLocal(), ...migrated }
  } else {
    return initLocal()
  }
}

// state
const state = {
  userConfigLocalStorage: '',
  local: initLocal(),
  session: initSession()
}

// getters
const getters = {
  remadv: (state) => state.session.remadv,
  remadvLines: (state) => state.session.remadvLines,
  queryRemadv: (state) => state.session.queryRemadv,
  listSelectedFiltersRemadv: (state) => state.session.listSelectedFiltersRemadv,
  // combos filtros
  optionsFilterServiceRemadv: (state) => state.session.optionsFilterServiceRemadv,
  optionsFilterBuyerRemadv: (state) => state.session.optionsFilterBuyerRemadv,
  optionsFilterCentrePayeeRemadv: (state) => state.session.optionsFilterCentrePayeeRemadv,
  optionsFilterSellerRemadv: (state) => state.session.optionsFilterSellerRemadv,
  optionsFilterRemadvNumberRemadv: (state) => state.session.optionsFilterRemadvNumberRemadv,
  optionsFilterInvoiceNumberRemadv: (state) => state.session.optionsFilterInvoiceNumberRemadv,
  optionsFilterIssueDateRemadv: (state) => state.session.optionsFilterIssueDateRemadv,
  optionsFilterTotalAmountRemadv: (state) => state.session.optionsFilterTotalAmountRemadv,
  optionsFilterDocumentDateRemadv: (state) => state.session.optionsFilterDocumentDateRemadv,
  // columnas tabla
  isShowServiceRemadv: (state) => state.local.isShowServiceRemadv,
  isShowBuyerRemadv: (state) => state.local.isShowBuyerRemadv,
  isShowCentrePayeeRemadv: (state) => state.local.isShowCentrePayeeRemadv,
  isShowSellerRemadv: (state) => state.local.isShowSellerRemadv,
  isShowRemadvNumberRemadv: (state) => state.local.isShowRemadvNumberRemadv,
  isShowDateCreationRemadv: (state) => state.local.isShowDateCreationRemadv,
  isShowDateIssueRemadv: (state) => state.local.isShowDateIssueRemadv,
  isShowTotalAmountRemadv: (state) => state.local.isShowTotalAmountRemadv,
  isShowActionsRemadv: (state) => state.local.isShowActionsRemadv,
  // columnas líneas
  isShowLineNumberRemadvLine: (state) => state.local.isShowLineNumberRemadvLine,
  isShowDocumentNumberRemadvLine: (state) => state.local.isShowDocumentNumberRemadvLine,
  isShowDocumentDateRemadvLine: (state) => state.local.isShowDocumentDateRemadvLine,
  isShowPaymentDateRemadvLine: (state) => state.local.isShowPaymentDateRemadvLine,
  isShowDocumentAmountRemadvLine: (state) => state.local.isShowDocumentAmountRemadvLine,
  isShowCentreRemadvLine: (state) => state.local.isShowCentreRemadvLine,
  isShowCentreDescriptionRemadvLine: (state) => state.local.isShowCentreDescriptionRemadvLine,
  isShowCurrencyRemadvLine: (state) => state.local.isShowCurrencyRemadvLine,
  isShowActionsRemadvLine: (state) => state.local.isShowActionsRemadvLine
}

// actions (alineadas con pedidos, ajustadas a un único tipo)
const actions = {
  // Crear key Usuario y cargar preferencias locales
  setUserNameRemadv ({ state }) {
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalRemadv()
    }
  },

  // Obtener listado principal REMADV
  async getRemadvs ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/remadv',

        params: { ...data.query },
        headers: { 'Accept-Language': data.activeLang },
        paramsSerializer: (params) => qs.stringify(convertDates(params), { indices: false })
      })
      commit('REMADV_STATE', {
        tableData: response.data.content,
        totalRemadv: response.data.totalElements
      })
      fn.assignJwt(commit, rootState.session?.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      throw error?.response || error
    }
  },

  // Detalle de un remadv
  async getRemadvDetail ({ rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/remadv/${params.remadvId}`,
        headers: { 'Accept-Language': params.activeLang },
        params: {
          searchType: params.searchType
        }
      })
      fn.assignJwt(null, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      throw error?.response || error
    }
  },

  // Original (XML, etc.)
  async downloadRemadvOriginal ({ rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/remadv/original',
        params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: (p) => qs.stringify(convertDates(p), { indices: false
          })
      })
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      let filename = 'remadv-original.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(
        response.headers['content-disposition']
      )
      if (fileGroup?.[2]) filename = fileGroup[2]
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(null, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error?.response || error
    }
  },

  // Metadata
  async downloadRemadvMetadata ({ rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/remadv/metadata',
        params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: (p) => qs.stringify(convertDates(p), { indices: false
          })
      })
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      let filename = 'remadv-metadata.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(
        response.headers['content-disposition']
      )
      if (fileGroup?.[2]) filename = fileGroup[2]
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(null, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error?.response || error
    }
  },

  // CSV export
  async downloadRemadvCsv ({ rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn && rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      // No forzar detalle aquí: el componente decide si es resumen (false) o detalle (true)
      // Mantener el valor que venga en params.isDetails
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/remadv/csv',
        params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: (p) => qs.stringify(convertDates(p), { indices: false
          })
      })
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      let filename = 'remadv.csv'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(
        response.headers['content-disposition']
      )
      if (fileGroup?.[2]) filename = fileGroup[2]
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(null, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error?.response || error
    }
  },

  // Líneas
  async getRemadvLines ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/remadv/${params.query.remadvId}/lines`,
        headers: { 'Accept-Language': params.activeLang },
        params: {
          searchType: params.searchType
        }
      })
      fn.assignJwt(null, rootState.session.jwt, response.headers.authorization)
      // Commit estado líneas
      // Se asume paginación backend similar (content/totalElements). Si no, adaptar.
      commit('REMADV_LINES_STATE', {
        tableData: response.data.content || response.data,
        totalRemadvLines:
          response.data.totalElements || (Array.isArray(response.data) ? response.data.length : 0)
      })
      return response.data
    } catch (error) {
      throw error?.response || error
    }
  },

  // Actualizar filtros activos
  listSelectedFiltersRemadvState ({ commit }, payload) {
    commit('LIST_SELECTED_FILTERS_REMADV_STATE', payload)
  },
  queryRemadvState ({ commit }, payload) {
    commit('QUERY_REMADV_STATE', payload)
  },
  remadvState ({ commit }, payload) {
    commit('REMADV_STATE', payload)
  },

  // Setters combos filtros
  optionsFilterServiceRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_SERVICE_REMADV', payload),
  optionsFilterBuyerRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_BUYER_REMADV', payload),
  optionsFilterCentrePayeeRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_CENTRE_PAYEE_REMADV', payload),
  optionsFilterSellerRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_SELLER_REMADV', payload),
  optionsFilterRemadvNumberRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_REMADV_NUMBER_REMADV', payload),
  optionsFilterDocumentDateRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_DOCUMENT_DATE_REMADV', payload),
  optionsFilterInvoiceNumberRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_INVOICE_NUMBER_REMADV', payload),
  optionsFilterIssueDateRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_ISSUE_DATE_REMADV', payload),
  optionsFilterTotalAmountRemadvState: ({ commit }, payload) =>
    commit('OPTIONS_FILTER_TOTAL_AMOUNT_REMADV', payload),

  // Column visibility actions
  isShowServiceRemadvAction: ({ commit }, payload) => commit('IS_SHOW_SERVICE_REMADV', payload),
  isShowBuyerRemadvAction: ({ commit }, payload) => commit('IS_SHOW_BUYER_REMADV', payload),
  isShowCentrePayeeRemadvAction: ({ commit }, payload) =>
    commit('IS_SHOW_CENTRE_PAYEE_REMADV', payload),
  isShowSellerRemadvAction: ({ commit }, payload) => commit('IS_SHOW_SELLER_REMADV', payload),
  isShowRemadvNumberRemadvAction: ({ commit }, payload) =>
    commit('IS_SHOW_REMADV_NUMBER_REMADV', payload),
  isShowDateCreationRemadvAction: ({ commit }, payload) =>
    commit('IS_SHOW_DATE_CREATION_REMADV', payload),
  isShowDateIssueRemadvAction: ({ commit }, payload) =>
    commit('IS_SHOW_DATE_ISSUE_REMADV', payload),
  isShowTotalAmountRemadvAction: ({ commit }, payload) =>
    commit('IS_SHOW_TOTAL_AMOUNT_REMADV', payload),
  isShowActionsRemadvAction: ({ commit }, payload) => commit('IS_SHOW_ACTIONS_REMADV', payload),
  // Column visibility actions líneas
  isShowLineNumberRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_LINE_NUMBER_REMADV_LINE', payload),
  isShowDocumentNumberRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_DOCUMENT_NUMBER_REMADV_LINE', payload),
  isShowDocumentDateRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_DOCUMENT_DATE_REMADV_LINE', payload),
  isShowPaymentDateRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_PAYMENT_DATE_REMADV_LINE', payload),
  isShowDocumentAmountRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_DOCUMENT_AMOUNT_REMADV_LINE', payload),
  isShowCentreRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_CENTRE_REMADV_LINE', payload),
  isShowCentreDescriptionRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_CENTRE_DESCRIPTION_REMADV_LINE', payload),
  isShowCurrencyRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_CURRENCY_REMADV_LINE', payload),
  isShowActionsRemadvLineAction: ({ commit }, payload) =>
    commit('IS_SHOW_ACTIONS_REMADV_LINE', payload)
}

// mutations
const mutations = {
  resetSessionRemadv (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  REMADV_STATE (state, payload) {
    state.session.remadv = payload
  },
  QUERY_REMADV_STATE (state, payload) {
    state.session.queryRemadv = payload
  },
  LIST_SELECTED_FILTERS_REMADV_STATE (state, payload) {
    state.session.listSelectedFiltersRemadv = payload
  },
  REMADV_LINES_STATE (state, payload) {
    state.session.remadvLines = payload
  },
  // combos filtros
  OPTIONS_FILTER_SERVICE_REMADV (state, payload) {
    state.session.optionsFilterServiceRemadv = payload
  },
  OPTIONS_FILTER_BUYER_REMADV (state, payload) {
    state.session.optionsFilterBuyerRemadv = payload
  },
  OPTIONS_FILTER_CENTRE_PAYEE_REMADV (state, payload) {
    state.session.optionsFilterCentrePayeeRemadv = payload
  },
  OPTIONS_FILTER_SELLER_REMADV (state, payload) {
    state.session.optionsFilterSellerRemadv = payload
  },
  OPTIONS_FILTER_REMADV_NUMBER_REMADV (state, payload) {
    state.session.optionsFilterRemadvNumberRemadv = payload
  },
  OPTIONS_FILTER_INVOICE_NUMBER_REMADV (state, payload) {
    state.session.optionsFilterInvoiceNumberRemadv = payload
  },
  OPTIONS_FILTER_ISSUE_DATE_REMADV (state, payload) {
    state.session.optionsFilterIssueDateRemadv = payload
  },
  OPTIONS_FILTER_TOTAL_AMOUNT_REMADV (state, payload) {
    state.session.optionsFilterTotalAmountRemadv = payload
  },
  OPTIONS_FILTER_DOCUMENT_DATE_REMADV (state, payload) {
    state.session.optionsFilterDocumentDateRemadv = payload
  },

  // Helper persist local flags
  IS_SHOW_SERVICE_REMADV (state, payload) {
    state.local.isShowServiceRemadv = payload
    persistLocal(state, 'isShowServiceRemadv', payload)
  },
  IS_SHOW_BUYER_REMADV (state, payload) {
    state.local.isShowBuyerRemadv = payload
    persistLocal(state, 'isShowBuyerRemadv', payload)
  },
  IS_SHOW_CENTRE_PAYEE_REMADV (state, payload) {
    state.local.isShowCentrePayeeRemadv = payload
    persistLocal(state, 'isShowCentrePayeeRemadv', payload)
  },
  IS_SHOW_SELLER_REMADV (state, payload) {
    state.local.isShowSellerRemadv = payload
    persistLocal(state, 'isShowSellerRemadv', payload)
  },
  IS_SHOW_REMADV_NUMBER_REMADV (state, payload) {
    state.local.isShowRemadvNumberRemadv = payload
    persistLocal(state, 'isShowRemadvNumberRemadv', payload)
  },
  IS_SHOW_DATE_CREATION_REMADV (state, payload) {
    state.local.isShowDateCreationRemadv = payload
    persistLocal(state, 'isShowDateCreationRemadv', payload)
  },
  IS_SHOW_DATE_ISSUE_REMADV (state, payload) {
    state.local.isShowDateIssueRemadv = payload
    persistLocal(state, 'isShowDateIssueRemadv', payload)
  },
  IS_SHOW_TOTAL_AMOUNT_REMADV (state, payload) {
    state.local.isShowTotalAmountRemadv = payload
    persistLocal(state, 'isShowTotalAmountRemadv', payload)
  },
  IS_SHOW_ACTIONS_REMADV (state, payload) {
    state.local.isShowActionsRemadv = payload
    persistLocal(state, 'isShowActionsRemadv', payload)
  },
  // Mutations columnas líneas
  IS_SHOW_LINE_NUMBER_REMADV_LINE (state, payload) {
    state.local.isShowLineNumberRemadvLine = payload
    persistLocal(state, 'isShowLineNumberRemadvLine', payload)
  },
  IS_SHOW_DOCUMENT_NUMBER_REMADV_LINE (state, payload) {
    state.local.isShowDocumentNumberRemadvLine = payload
    persistLocal(state, 'isShowDocumentNumberRemadvLine', payload)
  },
  IS_SHOW_DOCUMENT_DATE_REMADV_LINE (state, payload) {
    state.local.isShowDocumentDateRemadvLine = payload
    persistLocal(state, 'isShowDocumentDateRemadvLine', payload)
  },
  IS_SHOW_PAYMENT_DATE_REMADV_LINE (state, payload) {
    state.local.isShowPaymentDateRemadvLine = payload
    persistLocal(state, 'isShowPaymentDateRemadvLine', payload)
  },
  IS_SHOW_DOCUMENT_AMOUNT_REMADV_LINE (state, payload) {
    state.local.isShowDocumentAmountRemadvLine = payload
    persistLocal(state, 'isShowDocumentAmountRemadvLine', payload)
  },
  IS_SHOW_CENTRE_REMADV_LINE (state, payload) {
    state.local.isShowCentreRemadvLine = payload
    persistLocal(state, 'isShowCentreRemadvLine', payload)
  },
  IS_SHOW_CENTRE_DESCRIPTION_REMADV_LINE (state, payload) {
    state.local.isShowCentreDescriptionRemadvLine = payload
    persistLocal(state, 'isShowCentreDescriptionRemadvLine', payload)
  },
  IS_SHOW_CURRENCY_REMADV_LINE (state, payload) {
    state.local.isShowCurrencyRemadvLine = payload
    persistLocal(state, 'isShowCurrencyRemadvLine', payload)
  },
  IS_SHOW_ACTIONS_REMADV_LINE (state, payload) {
    state.local.isShowActionsRemadvLine = payload
    persistLocal(state, 'isShowActionsRemadvLine', payload)
  }
}

// helper outside mutation context
function persistLocal (state, key, value) {
  const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
  if (!storeuser.remadv) storeuser.remadv = {}
  storeuser.remadv[key] = value
  localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
}

export default {
  state,
  getters,
  actions,
  mutations
}
